import React, { memo, useCallback } from 'react';

import { AirportDocuments } from './AirportDocuments';
import { Limitations } from './Limitations';
import { Telegrams } from './Telegrams';
import { EFB_PREFLIGHT_ACCORDIONS_STATE, useLocalStorage } from '../../../hocs/useLocalStorage';
import { AIRPORT_DOCUMENTS, initialState, LIMITATIONS, TELEGRAMS } from './constants';

export const PreFlightPanel = memo(() => {
    const [value, setValue] = useLocalStorage(EFB_PREFLIGHT_ACCORDIONS_STATE, initialState);

    const handleChangeExpand = useCallback(
        (panel) => {
            setValue((prevValue) => ({
                ...prevValue,
                [panel]: !prevValue[panel],
            }));
        },
        [setValue]
    );

    return (
        <>
            <Telegrams expanded={value[TELEGRAMS]} onChangeExpand={handleChangeExpand} />
            <AirportDocuments expanded={value[AIRPORT_DOCUMENTS]} onChangeExpand={handleChangeExpand} />
            <Limitations expanded={value[LIMITATIONS]} onChangeExpand={handleChangeExpand} />
        </>
    );
});

PreFlightPanel.displayName = 'PreFlightPanel';
